






























import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'CustomerEventCard',
  props: {
    event: {
      type: Object as PropType<any>,
    },
  },
  computed: {
    eventDataList(): any[] {
      return Object.keys(this.event.eventData || {}).map((key) => {
        return {
          key,
          value: this.event.eventData[key],
          description: `${key}: ${this.event.eventData[key]}`,
        };
      });
    },
  },
});
